import { Chip } from '@themenu/design-system'

export const renderStatusWelcomeEmail = (
  status: Enum.WelcomeEmailStatus | undefined
) => {
  switch (status) {
    case 'SENT':
      return <Chip colorSet="success" label="Enviado" />

    case 'SCHEDULED':
      return <Chip colorSet="warning" label="Agendado" />

    case 'NOT_SENT':
      return <Chip colorSet="critical" label="Não enviado" />

    default:
      return <Chip colorSet="critical" label="-" />
  }
}
